import styled from '@emotion/styled';

export const Container = styled.div`
  padding: 0 12px;
  display: flex;
`;

export const ImageSection = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-right: 20px;
`;

export const InfoSection = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
